// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1wbo8vl0 {
  flex-basis: 100%;
}
._1wbo8vl1 {
  flex-basis: 100%;
}
._1wbo8vl2 {
  flex-basis: 100%;
}
._1wbo8vl3 {
  margin: var(--_18w76bwc) var(--_18w76bwg) var(--_18w76bwi);
}
._1wbo8vl4 {
  align-self: stretch;
  height: 200px;
}
@media screen and (min-width: 768px) {
  ._1wbo8vl3 {
    margin: 0;
    flex-basis: calc(40% - 8px);
  }
  ._1wbo8vl4 {
    flex-basis: 60%;
    height: auto;
    min-height: 600px;
  }
}
@media screen and (min-width: 1280px) {
  ._1wbo8vl0 {
    flex-basis: 46%;
  }
  ._1wbo8vl1 {
    flex-basis: 57%;
  }
  ._1wbo8vl2 {
    flex-basis: 49%;
  }
  ._1wbo8vl4 {
    min-height: unset;
    height: 425px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF","sourcesContent":["._1wbo8vl0 {\n  flex-basis: 100%;\n}\n._1wbo8vl1 {\n  flex-basis: 100%;\n}\n._1wbo8vl2 {\n  flex-basis: 100%;\n}\n._1wbo8vl3 {\n  margin: var(--_18w76bwc) var(--_18w76bwg) var(--_18w76bwi);\n}\n._1wbo8vl4 {\n  align-self: stretch;\n  height: 200px;\n}\n@media screen and (min-width: 768px) {\n  ._1wbo8vl3 {\n    margin: 0;\n    flex-basis: calc(40% - 8px);\n  }\n  ._1wbo8vl4 {\n    flex-basis: 60%;\n    height: auto;\n    min-height: 600px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  ._1wbo8vl0 {\n    flex-basis: 46%;\n  }\n  ._1wbo8vl1 {\n    flex-basis: 57%;\n  }\n  ._1wbo8vl2 {\n    flex-basis: 49%;\n  }\n  ._1wbo8vl4 {\n    min-height: unset;\n    height: 425px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
